import { useSite } from "../../context/SiteContext";
import { useWipe } from "../PageWipe";
import { Reveal, Overline } from "../Reveal";

const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7", "md:col-span-6", "md:col-span-6"];

export default function Projects() {
    const { site, tx } = useSite();
    const wipeTo = useWipe();
    const c = site?.content || {};
    const projects = (site?.projects || []).filter((p) => p.featured).slice(0, 6);

    if (!projects.length) return null;

    return (
        <section id="projects" data-testid="projects-section" className="grain relative bg-[#F4F3EF] px-6 py-32 text-[#0A0A0A] md:px-12 md:py-48 lg:px-24">
            <div className="flex flex-wrap items-end justify-between gap-6">
                <div>
                    <Overline testId="projects-overline">Featured work — 06</Overline>
                    <Reveal>
                        <h2 className="font-display mt-6 text-[clamp(3rem,7.5vw,7rem)] leading-[0.85]" data-testid="projects-title">
                            {tx(c.projects_title) || "SELECTED PROJECTS"}
                            <span className="text-[#D60024]">+</span>
                        </h2>
                    </Reveal>
                </div>
                <p className="max-w-xs text-sm text-black/60">
                    {tx({ en: "Ideas, partnerships and experiences built beyond the game.", pt: "Ideias, parcerias e experiências construídas para além do jogo." })}
                </p>
            </div>

            <div className="mt-24 grid gap-x-6 gap-y-24 md:grid-cols-12">
                {projects.map((p, i) => (
                    <Reveal key={p.id} className={`group relative ${SPANS[i % SPANS.length]}`} delay={(i % 2) * 0.1}>
                        <div
                            role="link"
                            tabIndex={0}
                            onClick={() => wipeTo(`/projects/${p.id}`)}
                            onKeyDown={(e) => e.key === "Enter" && wipeTo(`/projects/${p.id}`)}
                            data-testid={`project-card-${i}`}
                            data-cursor="plus"
                            className="block cursor-pointer"
                        >
                            <span className="font-display text-outline-b-soft pointer-events-none absolute -top-12 left-0 z-10 text-8xl md:-top-16 md:text-9xl" aria-hidden="true">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="overflow-hidden bg-[#0A0A0A]">
                                <img
                                    src={p.image_url}
                                    alt={tx(p.name)}
                                    loading="lazy"
                                    className="aspect-[4/3] w-full object-cover grayscale transition-all duration-700 ease-out group-hover:scale-[1.03] group-hover:grayscale-0"
                                />
                            </div>
                            <div className="mt-5 flex items-start justify-between gap-4">
                                <div>
                                    <h3 className="font-display text-3xl leading-none md:text-4xl">{tx(p.name)}</h3>
                                    <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-black/50">
                                        {p.client} — {tx(p.category)}
                                    </p>
                                </div>
                                <span className="font-display text-2xl text-[#D60024] transition-transform duration-300 group-hover:rotate-45" aria-hidden="true">+</span>
                            </div>
                            <p className="mt-3 max-w-md text-sm leading-relaxed text-black/60">{tx(p.description)}</p>
                            <span className="mt-2 block text-[11px] tracking-[0.25em] text-black/40">{p.year}</span>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
